import React, { PureComponent } from 'react';
import classNames from 'classnames';
import DisplayComponent from '../BaseComponents/DisplayComponent';
import './PopLockSection.module.css';

const PopLockSection = DisplayComponent(
  class PopLockSection extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        open: true
      };
      this.sectionToggle = this.sectionToggle.bind(this);
    }

    componentDidMount() {
      // TO DO: trigger open from table of contents
      // window.addEventListener('resize', this.resize);
      // this.resize();

      if (this.props.children.length !== 2) {
        console.log('This should have two children');
        return;
      }
    }

    resize = () => {
      this.setState({ open: window.innerWidth > 700 });
    };

    sectionToggle() {
      this.setState({
        open: !this.state.open
      });
    }

    render() {
      const { children, title, lockedItem, locked } = this.props;
      let sectionId = title.replace(/\s+/g, '-').toLowerCase();
      const childrenWithProps = React.Children.map(children, (child, index) =>
        React.cloneElement(child, {
          isLocked: locked,
          lockedSide: index === lockedItem
        })
      );
      return (
        <div
          styleName={classNames('pop-lock-section', `locked-${locked}`)}
          id={sectionId}
        >
          <span
            styleName={classNames('mobile-toggle', `open-${this.state.open}`)}
          >
            <h3>
              {title} <i styleName="fl-chevron" />
            </h3>
          </span>
          <div
            styleName={classNames(
              'pop-lock-container',
              `open-${this.state.open}`
            )}
          >
            {childrenWithProps}
          </div>
        </div>
      );
    }
  }
);

export default PopLockSection;
